import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { Card, CardContent, CardTitle } from '../../../../ui-kit';
import { Placeholder } from '../Placeholder';
import { PendingOrdersComponent } from '../../../../generated/graphql';
import PendingOrdersView from './PendingOrdersView';

const PendingOrders = () => {
    const { t } = useTranslation();

    return (
        <PendingOrdersComponent
            fetchPolicy='network-only'
            Loader={() => <Placeholder minHeight={294} />}
        >
            {({ data: { pendingOrders } }) => (
                <Card fullHeight>
                    <CardContent padding={3}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <CardTitle>{t('Pending orders')}</CardTitle>
                            </Grid>
                            <Grid item xs={12}>
                                <PendingOrdersView {...pendingOrders} />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            )}
        </PendingOrdersComponent>
    );
};
export default PendingOrders;